import { render, staticRenderFns } from "./BoatsForm.vue?vue&type=template&id=479edecd"
import script from "./BoatsForm.vue?vue&type=script&lang=js"
export * from "./BoatsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports